import { render, staticRenderFns } from "./CancelSendIcon.vue?vue&type=template&id=f6da0f58&scoped=true&"
import script from "./CancelSendIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CancelSendIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6da0f58",
  null
  
)

export default component.exports